import React from "react";

const formatNumber = (value) => Number(value || 0).toLocaleString();

const formatUpdatedAt = (value) => {
  if (!value) return "n/a";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "n/a";
  return date.toLocaleString();
};

const CommanderCard = ({
  title,
  profile,
  onChangeCommander,
  onEditProfile,
  disabled = false,
}) => {
  const power = profile?.powerSummary || {};
  const isCapturedCurrent = String(profile?.sourceType || profile?.profileKind || "") === "captured_current"
    || profile?.isCapturedCurrent === true;
  const sourceLabel = isCapturedCurrent ? "Captured current" : "Manual profile";
  return (
    <div className="commander-card">
      <div className="commander-card-head">
        <strong>{title}</strong>
        <span className="commander-card-updated">Updated: {formatUpdatedAt(profile?.updatedAt)}</span>
      </div>
      <div className="commander-card-name">{profile?.name || "No profile selected"}</div>
      <div className="commander-card-link">
        Source: {sourceLabel}
      </div>
      <div className="commander-card-link">
        Linked Commander: {profile?.linkedCommanderName || "None"}
      </div>
      {profile?.linkedReportBaselineId ? (
        <div className="commander-card-link">
          Linked Report Baseline: {String(profile.linkedReportBaselineId)}
        </div>
      ) : null}
      <div className="commander-card-grid">
        <span>BP {formatNumber(power.battlePower)}</span>
        <span>Officer {formatNumber(power.officerPower)}</span>
        <span>Titan {formatNumber(power.titanPower)}</span>
        <span>Warplane {formatNumber(power.warplanePower)}</span>
        <span>Antiques {formatNumber(power.antiquesPower)}</span>
        <span>Equipment {formatNumber(power.equipmentPower)}</span>
      </div>
      <div className="commander-card-actions">
        <button type="button" onClick={onChangeCommander} disabled={disabled}>
          Change Commander
        </button>
        <button type="button" onClick={onEditProfile} disabled={disabled || !profile?._id || isCapturedCurrent}>
          View/Edit Profile
        </button>
      </div>
    </div>
  );
};

export default CommanderCard;
